import { config as ControlNetConfig } from './ControlNet/config';

export const builtinExtensions = [
  ControlNetConfig
];
